// ManualPlateModal.tsx
import React from "react";
import { ManualPlateEntry } from "../components/manual-plate-entry";

export function ManualPlateModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <ManualPlateEntry onClose={onClose} />
    </div>
  );
}
